import { Component } from '@angular/core';
import { MunilyAvatarSize } from 'src/app/common-components/avatar/avatar.types';

@Component({
  selector: 'app-avatar-playground',
  templateUrl: './avatar-playground.component.html',
  styleUrls: ['./avatar-playground.component.scss'],
})
export class AvatarPlaygroundComponent {
  imageUrl = '';
  initials = 'JD';
  size: MunilyAvatarSize = 'medium';
  backgroundColor = '';
  alt = 'User avatar';

  lastEvent = '';

  readonly sizes: MunilyAvatarSize[] = ['small', 'medium', 'large'];
}
